/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo } from 'react';
import styles from '../../../../styles/components/pageComponents/learner/CoachingHours.module.css';
import Tooltip from '../../../../components/common/ToolTip';


import { useCoachingHours } from '../../../../hooks/useCoachingHours';

export type CoachingStatus = 'Approved' | 'Pending' | 'Rejected';

export interface CoachingRecord {
	id: string | number;
	name: string;
	hours: string;
	date: string;
	recordingName: string;
	status: CoachingStatus;
}

interface CoachingHoursProps {
	records: CoachingRecord[];
	loading?: boolean;
	onLogHours?: () => void;
}

export const CoachingHours: React.FC<CoachingHoursProps> = ({
	onLogHours,
	records,
	loading,
}) => {
	return (
		<div className={styles.container}>
			{/* Header section */}
			<div className={styles.header}>
				<h2 className={styles.title}>Coaching Hours</h2>
				<button
					className={styles.logButton}
					onClick={onLogHours}
					aria-label="Log coaching hours"
				>
					Log Coaching Hours{' '}
					<span className={styles.plusIcon}>+</span>
				</button>
			</div>

			{/* Main Table/Grid Container */}
			<div className={styles.tableWrapper}>
				{/* Desktop Header row (hidden on mobile) */}
				<div className={styles.desktopHeader}>
					<div className={styles.headerCell}>Name</div>
					<div className={styles.headerCell}>Number of Hours</div>
					<div className={styles.headerCell}>Date</div>
					<div className={styles.headerCell}>
						Recording/Transcript
					</div>
					<div className={styles.headerCell}>Status</div>
				</div>

				{/* Data Rows Container */}
				<div className={styles.tableBody}>
					{records.length === 0 ? (
						<div className={styles.emptyState}>
							No coaching hours found.
						</div>
					) : (
						records.map(record => (
							<div key={record.id} className={styles.row}>
								{/* Name */}
								<div className={styles.cell}>
									<span className={styles.mobileLabel}>
										Name
									</span>
									<span className={styles.cellValue}>
										{record.name}
									</span>
								</div>

								{/* Hours */}
								<div className={styles.cell}>
									<span className={styles.mobileLabel}>
										Number of Hours
									</span>
									<span className={styles.cellValue}>
										{record.hours}
									</span>
								</div>

								{/* Date */}
								<div className={styles.cell}>
									<span className={styles.mobileLabel}>
										Date
									</span>
									<span className={styles.cellValue}>
										{record.date}
									</span>
								</div>

								{/* Recording/Transcript */}
								<div className={styles.cell}>
									<span className={styles.mobileLabel}>
										Recording/Transcript
									</span>
									<span
										className={`${styles.cellValue} ${styles.truncate}`}
										title={record.recordingName}
									>
										{record.recordingName}
									</span>
								</div>

								{/* Status Badge */}
								<div
									className={`${styles.cell} ${styles.statusCell}`}
								>
									<span className={styles.mobileLabel}>
										Status
									</span>
									<span
										className={`${styles.badge} ${styles[record.status.toLowerCase()]}`}
									>
										{record.status}
									</span>
								</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
	);
};
